import { selectZillDevelopmentContentNode } from '@newStore/documentUI/transformContent/zillContentNodeSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const CURRICULUM_ZILL_DEVELOPMENT_CONTENT: BuildingBlockNodeConfig = {
  nodeSelector: selectZillDevelopmentContentNode,
  information: {
    single: 'Inhoud',
    plural: 'Inhouden',
  },
  buildingBlocks: [
    { type: NodeType.CURRICULUM_ZILL_DEVELOPMENT_CONTENT },
    {
      type: NodeType.CURRICULUM_ZILL_LEERLIJN,
      max: 1,
    },
    {
      type: NodeType.CURRICULUM_ZILL_LEERLIJN_AN,
      max: 1,
    },
  ],
  edit: [titleComponent],
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default CURRICULUM_ZILL_DEVELOPMENT_CONTENT;
